import React, { Component } from "react";
import ButtonAlt from "../ButtonAlt/ButtonAlt";
import "./NoMatch.css";

class NoMatch extends Component {
	render() {
		return (
			<div className="page-404 container">
				<h1>404</h1>
				<p>Sorry, we couldn't find the page you're looking for.</p>
				<ButtonAlt
					label="Go Back"
					onClick={() => this.props.changeLocation("/dashboard/search")}
				/>
			</div>
		);
	}
}

export default NoMatch;


// WEBPACK FOOTER //
// ./src/components/NoMatch/NoMatch.js